/* global Swiper */
Wee.fn.make('brands', {
	init: function() {
		this.solutionSwiper = $('ref:solutionSwiper');

		if (this.solutionSwiper.length) {
			this.$private.initSolutionSwiper();
		}
		this.$private.toggleBrandsList();
	},
	unload: function() {
		$.events.off(null, '.brands');

		if (this.solutionSwiper.length) {
			this.solutionSwiper[0].swiper.destroy();
		}
	}
}, {
	initSolutionSwiper: function() {
		var swiper = new Swiper(this.$public.solutionSwiper, {
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			slidesPerView: 'auto',
			spaceBetween: 10,
			touchRatio: 0.2
		});
	},
	toggleBrandsList: function() {
		$('ref:brandsToggle').on('click.brands', function(e, el) {
			$('ref:brandsList').toggle();
			$(el).toggleClass('-show');
		});
	}
});